// extracted by mini-css-extract-plugin
export default {"content":"VideoLinks_content__xBKWM","youtubeContainer":"VideoLinks_youtubeContainer__TZkJc","iframe":"VideoLinks_iframe__Ek4nE"};